var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{staticClass:"mt-4",attrs:{"show":"","variant":"warning"}},[_c('h2',[_vm._v(" 404 - Page not found ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }